import React from "react";

export default function LazySocialMedia() {
  return <div className="w-[1rem] h-[1rem] bg-gray-500 rounded-full"></div>;
}
